export enum EquipmentType {
    ManureSpreader,
    PressureWasher,
    HeatLamp,
    SlurryTanker,
    WasteIncinerator,
    PigTransportTrailer,
    Trailers,
    Compressor,
    Bowser,
    FertilizerSpreader,
    CultivationEquipment,
    StrawEquipment,
    BibbyTrailers,
    PiggeryEquipment,
    SlurryPumps,
    PigWeigher,
    Weighbridge,
    GrainDryer,
    MobileDryer,
    Generators,
    MillRepairs
}

export enum EquipmentTypeLabel {
    ManureSpreader = 'Manure Spreader',
    PressureWasher = 'Pressure Washer',
    HeatLamp = 'Heat Lamp',
    SlurryTanker = 'Slurry Tanker',
    WasteIncinerator = 'Waste Incinerator',
    PigTransportTrailer = 'Pig Transport Trailer',
    Trailers = 'Trailers',
    Compressor = 'Compressor',
    Bowser = 'Bowser',
    FertilizerSpreader = 'Fertilizer spreader',
    CultivationEquipment = 'Cultivation Equipment',
    StrawEquipment = 'Straw Equipment',
    BibbyTrailers = 'Bibby Trailers',
    PiggeryEquipment = 'Piggery Equipment',
    SlurryPumps = 'Slurry Pumps',
    PigWeigher = 'Pig Weigher',
    Weighbridge = 'Weighbridge',
    GrainDryer = 'Grain Dryer',
    MobileDryer = 'Mobile Dryer',
    Generators = 'Generators',
    MillRepairs = 'Mill Repairs'
}
